import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const PictureIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 7.375C11.9813 7.375 12.375 6.98125 12.375 6.5C12.375 6.01875 11.9813 5.625 11.5 5.625C11.0187 5.625 10.625 6.01875 10.625 6.5C10.625 6.98125 11.0187 7.375 11.5 7.375ZM14.125 3H1.875C1.39375 3 1 3.39375 1 3.875V12.625C1 13.1063 1.39375 13.5 1.875 13.5H14.125C14.6063 13.5 15 13.1063 15 12.625V3.875C15 3.39375 14.6063 3 14.125 3ZM13.25 10.875L8.875 8.25L8 10L5.375 6.5L2.75 10.875V4.75H13.25V10.875Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default PictureIcon;
